<template>
  <div :class="['card-content', schema.attributesCard.typeCard]" :style="borderColor(schema.attributesCard.color)">
    <v-card :class="['i4pro-timeline-card', !isGroup && 'elevation-2']" :outlined="true">
      <div v-for="(itemObj, indexObj) in listObjLine(card)" :key="indexObj">
        <div
          v-if="itemObj.key == 'title' && !isGroup"
          :class="['title', itemObj.class, borderTwoColor(itemObj.class)]"
          :style="titleBorderColor(schema.attributesCard.title.color)"
        >
          <span class="title-label" v-if="schema.attributesCard.title.display" v-html="itemObj.title"></span>
          <span v-html="itemObj.value"></span>
        </div>

        <div v-else-if="itemObj.key == 'users'" :class="['line-default users', itemObj.class]">
          <span v-if="itemObj.isBg">
            <v-chip
              small
              :color="itemObj.color ? itemObj.color : 'grey'"
              :text-color="!schema.attributesCard.textOutlined ? 'white' : itemObj.color"
              :outlined="schema.attributesCard.textOutlined"
              v-html="itemObj.title"
            >
            </v-chip>
          </span>
          <span v-html="itemObj.title" v-else></span>

          <ul :class="['listUsers', schema.attributesCard.users.type]">
            <li
              v-for="(user, indexUser) in listUsers(itemObj.value, schema.attributesCard.users.type)"
              :key="indexUser"
            >
              <v-chip
                small
                v-bind="schema.attributesChips"
                :color="schema.attributesChips.color ? schema.attributesChips.color : 'grey'"
                v-if="schema.attributesCard.users.type == 'users-bg'"
              >
                <v-avatar left>
                  <v-icon small>mdi-account-circle</v-icon>
                </v-avatar>
                {{ user }}
              </v-chip>

              <template v-else>
                <v-tooltip top :color="schema.attributesCard.users.color">
                  <template v-slot:activator="{ on, attrs }">
                    <div
                      :data-has-tooltip="user.name ? 'true' : 'false'"
                      :data-tooltip="user.name"
                      v-on="on"
                      v-bind="attrs"
                      class="usersImg"
                      :style="`background-image: url(${user.img}); ${borderColor(schema.attributesCard.color)}`"
                    ></div>
                  </template>
                  <span>{{ user.name }}</span>
                </v-tooltip>
              </template>
            </li>
          </ul>
        </div>

        <div v-else-if="itemObj.key != 'title'" :class="[itemObj.class, 'line-default']">
          <span v-if="itemObj.isBg">
            <v-chip
              small
              :color="itemObj.color ? itemObj.color : 'grey'"
              :text-color="!schema.attributesCard.textOutlined ? 'white' : itemObj.color"
              :outlined="schema.attributesCard.textOutlined"
              v-html="itemObj.title"
            >
            </v-chip>
          </span>

          <span v-html="itemObj.title" v-else></span>

          <p v-html="itemObj.value"></p>
        </div>
      </div>

      <div
        :class="['d-flex', 'flex-wrap', schema.attributesCard.typeAlignActions]"
        v-if="schema.actions && schema.actions.items.length > 0"
      >
        <v-btn
          @click="execute(action)"
          v-bind="action.attributes"
          :disabled="action.readonly"
          v-for="(action, i) in schema.actions.items"
          :key="i"
        >
          <v-icon
            v-if="action.attributesIcon.icon && !action.attributesIcon.right"
            v-bind="action.attributesIcon"
            class="mr-1"
          >
            {{ action.attributesIcon.icon }}
          </v-icon>
          {{ action.label }}
          <v-icon
            v-if="action.attributesIcon.icon && action.attributesIcon.right"
            v-bind="action.attributesIcon"
            class="ml-1"
          >
            {{ action.attributesIcon.icon }}
          </v-icon>
        </v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
import * as HANDLERS from '@/helpers/types/handlers';

export default {
  data() {
    return {
      actionName: ''
    };
  },

  props: {
    schema: { type: Object, default: () => ({}) },
    card: { type: Object, default: () => ({}) },
    isGroup: { type: Boolean, default: () => true },
    formOptions: { type: Object, default: () => ({}) }
  },

  methods: {
    borderColor(color) {
      return color == 'primary' ? `border-color: var(--v-primary-base);` : `border-color: ${color};`;
    },

    borderTwoColor(color) {
      let borderTwo = color.indexOf('title-border-two') >= 0;

      return (
        borderTwo &&
        `border-two-left-${this.schema.attributesCard.color} border-two-right-${this.schema.attributesCard.title.color}`
      );
    },

    titleBorderColor(color) {
      let getColor = color ? color : this.schema.attributesCard.color;

      return getColor == 'primary' ? `border-color: var(--v-primary-base)` : `border-color: ${getColor};`;
    },

    listUsers(users, type) {
      const userSplit = users.split(';');
      let listUsersImg = [];

      if (type == 'users-bg') {
        return userSplit;
      }

      userSplit.forEach(objItem => {
        let dataSplit = objItem.split('[]');

        listUsersImg.push({
          name: dataSplit[0],
          img: dataSplit[1]
        });
      });

      return listUsersImg;
    },

    listObjLine(item) {
      let list = [];
      const card = Object.keys(item);

      this.schema.attributes.headers.forEach(headerItem => {
        card.forEach(objItem => {
          if (headerItem.value == objItem) {
            list.push({
              title: headerItem.text,
              value: item[headerItem.value],
              class: headerItem.class,
              color: headerItem.color ? headerItem.color : 'grey',
              key: headerItem.value,
              isBg: headerItem.class.indexOf('text-bg') >= 0
            });
          }
        });
      });

      return list;
    },

    execute(action) {
      action.mode = this.formOptions.mode;

      this.$emit(HANDLERS.EXECUTE_ACTION, { action, origin: this.formOptions.page, model: this.card });
    }
  }
};
</script>

<style lang="scss" scoped>
.i4pro-timeline-card {
  border: none;
}
</style>
